<template>
    <div class="progressbar-container">
        <ul class="progressbar">
            <li v-for="(step, index) in steps"
                :key="index"
                :class="{ active: isActiveTab(index) }"
                :data-step="index+1"
                @click="selectStep(index)">
                {{ step }}
            </li>
        </ul>
    </div>
</template>

<script>
import {defineComponent} from "vue";

export default defineComponent({
    name: 'stepProgressBar',
    props: {
        steps: {
            type: Array,
            required: true
        },
        activeStep: {
            type: Number,
            required: true
        }
    },
    setup(props, { emit }) {
        const isActiveTab = (index) => {
            return index <= props.activeStep;
        }

        const selectStep = (step) => {
            emit("step-selected", step);
        }

        return {isActiveTab, selectStep}
    }
})
</script>

<style scoped lang="scss">
$primary-color: black;

.progressbar-container {
  z-index: 1;
}

.progressbar {
  display: flex;
  width: 100%;
  list-style: none;
  padding: 0;
  justify-content: space-between;
}

.progressbar li {
  flex-grow: 1;
  position: relative;
  text-align: center;
  min-width: 33%;
}

.progressbar li:before {
  content: attr(data-step);
  width: 30px;
  height: 30px;
  border: 2px solid #bebebe;
  display: block;
  margin: 0 auto 10px auto;
  border-radius: 50%;
  line-height: 30px;
  background: white;
  color: #bebebe;
  text-align: center;
  font-weight: bold;
}

.progressbar li:after {
  content: '';
  position: absolute;
  width: 100%;
  height: 3px;
  background: #979797;
  top: 15px;
  left: -50%;
  z-index: -1;
}

.progressbar li.active:before {
  border-color: $primary-color;
  background: $primary-color;
  color: white;
  transition: border-color 1s ease-in-out, background 1s ease-in-out, color 1s ease-in-out;
}

.progressbar li.active:after {
  background: $primary-color;
  transition: background 1s ease-in-out;
}

.progressbar li:first-child:after {
  content: none;
}

ul.progressbar > *::after, *::before {
    box-sizing: unset;
}
</style>